module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"connection":"Merci de patienter","connection-message":"Identification en cours.","error":"Erreur","ok":"Succès","ok-message":"Vous êtes authentifié"},"en":{"connection":"Please wait","connection-message":"Identification in process","error":"Error","ok":"Success","ok-message":"You are logged in"}}')
  delete Component.options._Ctor
}
